
import { defineComponent, SetupContext, computed, ref } from "vue";
import NativeClient from "@/client/native-client";
import { CandidateInfo } from "@/types/pantry";

export default defineComponent({
  name: "PantryFoodCheckItem",
  components: {
  },
  props: {
    data: {
      type: CandidateInfo,
      default: null,
      require: true
    },
    isLarge: {
      type: Boolean,
      default: false,
      require: true
    },
    isFoodTimerExec: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    const isCheck = ref(false);
    const checkImage = ref<HTMLImageElement>();
    const getImage = () => {
      return (props.data && props.data.imageUrl) ? props.data.imageUrl : "";
    };
    const onImageError = (event: Event) => {
      NativeClient.sendDebugLog("PantryFoodCheckItem onImageError");
      if (event.target) {
        (event.target as HTMLImageElement).src = require("@/assets/images/food_noimage.png");
      }
    };
    const getName = () => {
      return (props.data) ? props.data.name : null;
    };
    const styleImageArea = computed(() => {
      const width = (props.isLarge) ? "12" : "7.5";
      const height = width;
      return { 'width': `${width}rem`, 'height': `${width}rem` };
    });
    const styleCheckImageArea = computed(() => {
      const width = (props.isLarge) ? 12 : 7.5;
      const height = width;
      return { 'width': `${width}rem`, 'height': `${width}rem` };
    });
    const styleImage = computed(() => {
      const width = (props.isLarge) ? "8.5" : "5";
      const height = width;
      return { 'width': `${width}rem`, 'height': `${width}rem` };
    });
    const styleText = computed(() => {
      const fontSize = (props.isLarge) ? "1.6" : "1.3";
      return { 'font-size': `${fontSize}rem` };
    });

    const loadPng = () => {
      NativeClient.sendDebugLog("PantryFoodCheckItem loadPng start");
      if (checkImage.value == undefined) {
        NativeClient.sendDebugLog("PantryFoodCheckItem loadPng error");
        return;
      }
      const timestamp = new Date().getTime();
      checkImage.value.src = require("@/assets/images/foodcheck_anime.png") + "?" + timestamp;
      checkImage.value.onload = function() {
        if (checkImage.value == undefined) {
          NativeClient.sendDebugLog("PantryFoodCheckItem loadPng onload error");
          return;
        }
      };
    }
    const clickFood = () => {
      NativeClient.sendDebugLog("PantryFoodCheckItem clickFood start isFoodTimerExec=" + props.isFoodTimerExec);
      if (props.isFoodTimerExec) {
        return;
      }
      isCheck.value = true;
      loadPng();
      context.emit("click-food", props.data);
    };
    return {
      getImage,
      getName,
      styleImageArea,
      styleImage,
      styleText,
      clickFood,
      isCheck,
      styleCheckImageArea,
      checkImage,
      onImageError
    };
  }
});
